import { memo } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'

const Footer = ({ onCancel, loading = false }) => {
  return (
    <S.Grid>
      <Button size="kilo" type="submit" isStretch>
        {loading ? 'Aguarde...' : 'Enviar'}
      </Button>
      <Button
        size="kilo"
        type="button"
        variant="outline"
        onClick={onCancel}
        disabled={loading}
        isStretch
      >
        Enviar depois
      </Button>
    </S.Grid>
  )
}

Footer.propTypes = {
  onCancel: PropTypes.func,
  loading: PropTypes.bool.isRequired
}

export default memo(Footer)
